<template>
  <div>
    <v-dialog
      v-model="dialog"
      v-if="dialog"
      content-class="my-custom-dialog"
      transition="dialog-top-transition"
      @keydown.esc="close"
      scrollable
      width="30%"
      height="20%"
    >
      <v-card class="glass-card">
        <v-card-title class="glass-header pa-4">
          <v-icon color="white" size="28" class="mr-2">mdi-pencil</v-icon>
          <span class="header-text">Izmjene</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <!-- Naziv artikla -->
          <div class="item-name-section text-center mb-6">
            <div class="item-name">{{ item.name }}</div>
          </div>

          <!-- Količina kontrole -->
          <div class="quantity-section mb-6">
            <v-row align="center" justify="center" class="ma-0">
              <v-col cols="auto" class="pa-0">
                <v-btn
                  fab
                  x-large
                  color="error"
                  class="quantity-btn minus-btn"
                  @click="menuClick('decrement')"
                  elevation="4">
                  <v-icon size="36" color="white">mdi-minus</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto" class="pa-0 mx-8">
                <div class="quantity-display">
                  <v-text-field
                    v-model="item.quantity"
                    @input="normalizeQuantityInput"
                    @change="callRecalculate()"
                    @focus="selectAllText"
                    ref="quantityInput"
                    class="quantity-input"
                    outlined
                    dense
                    hide-details
                    solo
                    flat>
                  </v-text-field>
                </div>
              </v-col>

              <v-col cols="auto" class="pa-0">
                <v-btn
                  fab
                  x-large
                  color="success"
                  class="quantity-btn plus-btn"
                  @click="menuClick('increment')"
                  elevation="4">
                  <v-icon size="36" color="white">mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!-- Ukupno -->
          <v-card outlined class="total-card" elevation="0">
            <v-card-text class="pa-4 text-center">
              <div class="total-label">Ukupno</div>
              <div class="total-amount">
                {{ $options.filters.money(itemTotal, 100, currency) }}
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider class="footer-divider"></v-divider>
        <v-card-actions class="pa-4 footer-actions">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-large
                @click="menuClick('addDiscount')"
                class="discount-icon-btn"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="#4CAF50" size="40">mdi-percent</v-icon>
              </v-btn>
            </template>
            <span>Dodaj popust</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-large
                @click="menuClick('addNoteArticleDialogOpen')"
                class="note-icon-btn ml-4"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="#3989C9" size="40">mdi-note-text</v-icon>
              </v-btn>
            </template>
            <span>Dodaj napomenu</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-btn
            class="danger-footer-btn"
            elevation="0"
            large
            @click="deleteItem"
          >
            Obriši
          </v-btn>
          <v-btn
            class="success-footer-btn ml-3"
            elevation="0"
            large
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      item: {},
      currency: 'EUR'
    }
  },
  computed: {
    itemTotal () {
      const qty = parseFloat(this.item.quantity) || 0
      const price = this.item.discountedUnitPrice || this.item.unitPrice || 0
      return Math.round(qty * price)
    }
  },
  methods: {
    deleteItem () {
      this.item.quantity = 1
      this.$emit('itemMenuClick', 'decrement', this.item)
      this.close()
    },
    open (item) {
      this.item = item
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    selectAllText (event) {
      // Auto-select all text when input is focused
      event.target.select()
    },
    menuClick (method) {
      var closeOnDecrement = false
      if (this.item.quantity <= 1 && method === 'decrement') {
        closeOnDecrement = true
      }

      this.$emit('itemMenuClick', method, this.item)
      if ((method !== 'increment' && method !== 'decrement')) {
        this.close()
      }

      setTimeout(() => {
        if (closeOnDecrement) {
          this.close()
        }
      }, 50)
    },
    normalizeQuantityInput (value) {
      if (typeof value === 'string' && value.includes(',')) {
        this.item.quantity = value.replace(',', '.')
      }
    },
    callRecalculate () {
      if (typeof this.item.quantity === 'string') {
        const parsed = parseFloat(this.item.quantity)
        this.item.quantity = isNaN(parsed) ? 1 : Math.round(parsed * 10000) / 10000
      }
      this.$emit('recalculate')
    }
  }
}
</script>

<style scoped>
/* Glass Card Style */
.glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  box-shadow: 0 8px 32px rgba(57, 137, 201, 0.15) !important;
  overflow: hidden;
}

/* Header with Brand Gradient */
.glass-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  position: relative;
  border-bottom: 1px solid rgba(57, 137, 201, 0.3);
}

.glass-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  z-index: 0;
}

.header-text {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: white !important;
  letter-spacing: 0.3px !important;
  position: relative;
  z-index: 1;
}

.close-btn {
  position: relative;
  z-index: 1;
  transition: all 0.2s ease !important;
}

.close-btn:hover {
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Footer */
.footer-divider {
  border-color: rgba(57, 137, 201, 0.2) !important;
}

.footer-actions {
  background: rgba(57, 137, 201, 0.02) !important;
}

/* Item Name Section */
.item-name-section {
  padding: 12px 0;
}

.item-name {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: rgba(70, 70, 80, 0.95) !important;
  text-transform: uppercase;
  letter-spacing: 0.5px !important;
  line-height: 1.3;
}

/* Quantity Section */
.quantity-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Quantity Buttons */
.quantity-btn {
  width: 72px !important;
  height: 72px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.quantity-btn:hover {
  transform: scale(1.08) !important;
}

.quantity-btn:active {
  transform: scale(0.95) !important;
}

.minus-btn {
  background: linear-gradient(135deg, #F44336 0%, #D32F2F 100%) !important;
}

.plus-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
}

/* Quantity Display */
.quantity-display {
  width: 140px;
}

.quantity-input >>> input {
  text-align: center !important;
  font-size: 48px !important;
  font-weight: 700 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  padding: 32px 0 !important;
  line-height: 1 !important;
  min-height: 110px !important;
}

.quantity-input >>> .v-input__control {
  min-height: auto !important;
}

.quantity-input >>> fieldset {
  border: 3px solid rgba(57, 137, 201, 0.3) !important;
  border-radius: 16px !important;
}

.quantity-input >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Total Card */
.total-card {
  border: 2px solid rgba(57, 137, 201, 0.2) !important;
  border-radius: 16px !important;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.05) 0%,
    rgba(57, 137, 201, 0.03) 100%) !important;
}

.total-label {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: rgba(70, 70, 80, 0.7) !important;
  text-transform: uppercase;
  letter-spacing: 1px !important;
  margin-bottom: 8px;
}

.total-amount {
  font-size: 42px !important;
  font-weight: 700 !important;
  color: #3989C9 !important;
  letter-spacing: 0.5px !important;
}

/* Discount Icon Button */
.discount-icon-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
}

.discount-icon-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(76, 175, 80, 0.1);
  transform: scale(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.discount-icon-btn:hover::before {
  transform: scale(1);
}

.discount-icon-btn:hover {
  transform: scale(1.1) rotate(5deg);
}

.discount-icon-btn:hover .v-icon {
  color: #4CAF50 !important;
  filter: drop-shadow(0 2px 8px rgba(76, 175, 80, 0.4));
}

/* Note Icon Button */
.note-icon-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
}

.note-icon-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(57, 137, 201, 0.1);
  transform: scale(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.note-icon-btn:hover::before {
  transform: scale(1);
}

.note-icon-btn:hover {
  transform: scale(1.1) rotate(-5deg);
}

.note-icon-btn:hover .v-icon {
  color: #3989C9 !important;
  filter: drop-shadow(0 2px 8px rgba(57, 137, 201, 0.4));
}

/* Danger Button (Delete) */
.danger-footer-btn {
  background: rgba(244, 67, 54, 0.9) !important;
  color: white !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  min-width: 100px !important;
  height: 44px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.danger-footer-btn:hover {
  background: rgba(244, 67, 54, 1) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(244, 67, 54, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Success Button (OK) */
.success-footer-btn {
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  min-width: 100px !important;
  height: 44px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.success-footer-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  border-color: #3989C9 !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  transform: translateY(-1px);
}

/* Legacy styles for existing content */
span.darkblue {
  color: #275281;
}

@media only screen and (max-height: 899px) {
  #container {
    max-height: 193px;
  }
  span.tile {
    display: block;
    white-space: normal;
  }
}

.panel-row-inactive {
  background-color: #816827;
}

@media only screen and (min-height: 900px) {
  #container {
    max-height: 440px;
  }
  span.tile {
    display: block;
    white-space: normal;
  }
}

.btn-lg {
  font-size: 1.5rem;
  font-weight: 700;
}

.kolicina >>> input {
  text-align: center;
}
</style>
